var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLapisEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5084 0.451084C10.964 -0.00452869 11.7027 -0.00452714 12.1583 0.451084L13.8822 2.17494C14.3378 2.63055 14.3378 3.36925 13.8822 3.82486L12.0202 5.68679L12.0119 5.69491L4.7932 12.5855C4.66132 12.7114 4.50176 12.8046 4.32734 12.8577L0.645594 13.9782C0.468938 14.032 0.277031 13.984 0.146459 13.8535C0.0158878 13.7229 -0.0320889 13.531 0.0216758 13.3543L1.13741 9.68833C1.19584 9.49634 1.30281 9.32267 1.44798 9.18411L8.65057 2.3089L10.5084 0.451084ZM8.99189 3.36555L2.13845 9.90746C2.11771 9.92726 2.10243 9.95207 2.09408 9.97949L1.25131 12.7486L4.03618 11.901C4.06109 11.8934 4.08389 11.8801 4.10273 11.8621L10.9513 5.32492L8.99189 3.36555ZM11.6667 4.62613L13.1751 3.11775C13.2401 3.05266 13.2401 2.94714 13.1751 2.88205L11.4512 1.15819C11.3861 1.0931 11.2806 1.0931 11.2155 1.15819L9.70712 2.66657L11.6667 4.62613Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLapisEditar);
export default __webpack_public_path__ + "static/media/lapisEditar.09f42ec7be7b3505099eb13a7697f571.svg";
export { ForwardRef as ReactComponent };